module.exports = __webpack_public_path__ + "img/home-412.6072669b.webp";